module.exports = __webpack_public_path__ + "@/assets/img/03.337fe28d.svg";